import { render, staticRenderFns } from "./WcTablesWrapperDefault.vue?vue&type=template&id=37680517&lang=pug&"
import script from "./WcTablesWrapperDefault.vue?vue&type=script&lang=js&"
export * from "./WcTablesWrapperDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports